import script from "./SelectEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectEvent.vue?vue&type=script&setup=true&lang=js"

import "./SelectEvent.vue?vue&type=style&index=0&id=a3a5132e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3a5132e"]])

export default __exports__